import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
    selector: 'esign-sso-cookie',
    templateUrl: 'esign-sso-cookie.component.html',
    standalone: false
})
export class EsignSsoCookieComponent implements OnInit {

  constructor(
    private readonly _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this._activatedRoute.queryParamMap.pipe(take(1)).subscribe((params) => {
      const token = params.get('token');
      if (token) {
        document.cookie = `sso_auth_completion_token=${token}; path=/; max-age=300; secure; SameSite=None`;
        window.close();
      }
    });
  }
}
